export default function createGreenScreenFilter() {
    return new PIXI.Filter(null, `
    precision mediump float;
    varying vec2 vTextureCoord;
    uniform sampler2D uSampler;

    void main(void) {

        gl_FragColor = texture2D(uSampler, vTextureCoord);

        if (gl_FragColor.r == 0. && gl_FragColor.b == 0. && gl_FragColor.g == 1.0) {
            gl_FragColor.a = 0.;
            gl_FragColor.r = 0.;
            gl_FragColor.g = 0.;
            gl_FragColor.b = 0.;
        }
    }
`);
}
